import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

type Props = {
  title?: string;
  description?: string;
  image?: string;
  canonical?: string;
  type?: "website" | "article";
  noindex?: boolean;
  locale?: string;
};

const SITE_NAME = "Isola Dei Mori";
const BASE_URL = "https://www.isoladeimori.it";
const DEFAULT_DESCRIPTION =
  "Isola Dei Mori: case vacanza e ospitalità a Sant'Antioco, Sardegna.";
const DEFAULT_IMAGE = `${BASE_URL}/icon-512.png`;
const DEFAULT_LOCALE = "it_IT";

export const Seo = ({
  title,
  description = DEFAULT_DESCRIPTION,
  image = DEFAULT_IMAGE,
  canonical,
  type = "website",
  noindex = false,
  locale = DEFAULT_LOCALE,
}: Props) => {
  const location = useLocation();
  const path = location.pathname === "/" ? "" : location.pathname;
  const canonicalUrl = canonical || `${BASE_URL}${path}`;
  const pageTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content={type} />
      <meta property="og:locale" content={locale} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};
